'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _recompose = require('recompose');

var _reselect = require('reselect');

var _elementActions = require('../../element/elementActions');

var _selectionActions = require('../../element/selection/selectionActions');

var _currentlyEditingSelector = require('../../element/selection/currentlyEditingSelector');

var _contentEditable = require('../../utils/keyboard/contentEditable');

var _domUtil = require('../../utils/domUtil');

var _undoRedoTransactionManager = require('../../utils/undoRedo/undoRedoTransactionManager');

var _keyConstants = require('../../utils/keyboard/keyConstants');

require('./EditableTitle.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Actions


// Utils


// Constants


// Styles


var DEFAULT_MAX_LENGTH = 100;

var getTitle = function getTitle(state, _ref) {
    var element = _ref.element,
        initialValue = _ref.initialValue;
    return element && element.getIn(['content', 'title']) || initialValue;
};

var titleEditorSelector = (0, _reselect.createStructuredSelector)({
    title: getTitle,
    isEditing: _currentlyEditingSelector.getIsCurrentlyEditingThisElement
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchUpdateTitle: function dispatchUpdateTitle(id, title, transactionId) {
            return dispatch((0, _elementActions.updateElement)({ id: id, changes: { title: title }, transactionId: transactionId }));
        },
        dispatchStartEditingTitle: function dispatchStartEditingTitle(id, editDelay, editorKey) {
            return editDelay ? dispatch((0, _selectionActions.startEditingElementWithDelay)({ id: id, editorKey: editorKey, editDelay: editDelay })) : dispatch((0, _selectionActions.startEditingElement)({ id: id, editorKey: editorKey }));
        },
        dispatchStopEditingTitle: function dispatchStopEditingTitle() {
            dispatch((0, _selectionActions.finishEditingElement)());
            dispatch((0, _selectionActions.deselectAllElements)());
        }
    };
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(titleEditorSelector, mapDispatchToProps), (0, _recompose.defaultProps)({ maxLength: DEFAULT_MAX_LENGTH }), _recompose.onlyUpdateForPropTypes);

var EditableTitle = function (_React$Component) {
    _inherits(EditableTitle, _React$Component);

    function EditableTitle() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, EditableTitle);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = EditableTitle.__proto__ || Object.getPrototypeOf(EditableTitle)).call.apply(_ref2, [this].concat(args))), _this), _this.onKeyDown = function (event) {
            if (event.metaKey) {
                if (event.keyCode === _keyConstants.KEY_CODES.B || event.keyCode === _keyConstants.KEY_CODES.I) {
                    event.preventDefault();
                }
            }
            if (event.keyCode === _keyConstants.KEY_CODES.ENTER || event.keyCode === _keyConstants.KEY_CODES.ESC) {
                event.preventDefault();
                _this.props.dispatchStopEditingTitle();
            }
        }, _this.onDoubleClick = function (event) {
            if (_this.props.isEditing) {
                event.stopPropagation();
            }
        }, _this.onBlur = function (event) {
            _this.updateTitle(_this.getTitleText());
        }, _this.getTitleText = function () {
            return _this.cleanTitleText(_this.titleInput.innerText);
        }, _this.updateTitle = function (title) {
            var _this$props = _this.props,
                isEditable = _this$props.isEditable,
                elementId = _this$props.elementId,
                dispatchUpdateTitle = _this$props.dispatchUpdateTitle,
                onUpdateCallbackFn = _this$props.onUpdateCallbackFn;

            if (title === _this.props.title) return;

            if (!isEditable) return;

            if (title === '') {
                _this.titleInput.innerText = _this.props.title;
                return;
            }

            var transactionId = (0, _undoRedoTransactionManager.getNewTransactionId)();
            dispatchUpdateTitle(elementId, title, transactionId);
            onUpdateCallbackFn && onUpdateCallbackFn({ title: title, transactionId: transactionId });
        }, _this.startEditingTitle = function (event) {
            var _this$props2 = _this.props,
                isEditable = _this$props2.isEditable,
                selectFirst = _this$props2.selectFirst,
                isSelected = _this$props2.isSelected,
                editDelay = _this$props2.editDelay,
                elementId = _this$props2.elementId,
                dispatchStartEditingTitle = _this$props2.dispatchStartEditingTitle,
                editorKey = _this$props2.editorKey;


            if (!isEditable) return;
            if (selectFirst && !isSelected) return;

            dispatchStartEditingTitle(elementId, editDelay, editorKey);
        }, _this.handlePasteEvent = function (event) {
            // cancel paste
            event.preventDefault();

            // get text representation of clipboard
            var text = (event.originalEvent || event).clipboardData.getData('text/plain');

            // insert text manually
            document.execCommand('insertHTML', false, _this.cleanTitleText(text));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(EditableTitle, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.titleInput.addEventListener('paste', this.handlePasteEvent);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var isEditing = this.props.isEditing;


            if (isEditing && !nextProps.isEditing) {
                this.updateTitle(this.getTitleText());
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                isEditing = _props.isEditing,
                selectAllOnEdit = _props.selectAllOnEdit;


            if (isEditing && !prevProps.isEditing) {
                if (this.titleInput) {
                    selectAllOnEdit ? (0, _contentEditable.selectAll)(this.titleInput) : (0, _contentEditable.placeCaretAtEnd)(this.titleInput);
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.titleInput.removeEventListener('paste', this.handlePasteEvent);
        }
    }, {
        key: 'cleanTitleText',
        value: function cleanTitleText(title) {
            var maxLength = this.props.maxLength;


            if (!title) return;

            return title.replace('\n', '').substring(0, maxLength);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                title = _props2.title,
                isEditing = _props2.isEditing,
                wrapTitleElement = _props2.wrapTitleElement;


            var titleText = this.cleanTitleText(title);

            return _react2.default.createElement(
                'div',
                { className: 'EditableTitle' },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('editable-title', { editing: isEditing }),
                        ref: function ref(c) {
                            _this2.titleInput = c;
                        },
                        onClick: this.startEditingTitle,
                        contentEditable: isEditing,
                        suppressContentEditableWarning: true,
                        onKeyDown: this.onKeyDown,
                        onMouseDown: _domUtil.stopPropagationOnly,
                        onDoubleClick: this.onDoubleClick,
                        onBlur: this.onBlur },
                    wrapTitleElement && !isEditing ? _react2.default.cloneElement(wrapTitleElement, null, titleText) : titleText
                )
            );
        }
    }]);

    return EditableTitle;
}(_react2.default.Component);

EditableTitle.propTypes = {
    element: _propTypes2.default.object,
    elementId: _propTypes2.default.string,
    title: _propTypes2.default.string,
    editorKey: _propTypes2.default.string,
    dispatchUpdateTitle: _propTypes2.default.func,
    dispatchStartEditingTitle: _propTypes2.default.func,
    dispatchStopEditingTitle: _propTypes2.default.func,
    onUpdateCallbackFn: _propTypes2.default.func,
    wrapTitleElement: _propTypes2.default.element,
    maxLength: _propTypes2.default.number,
    isEditing: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    selectFirst: _propTypes2.default.bool,
    selectAllOnEdit: _propTypes2.default.bool,
    editDelay: _propTypes2.default.number
};

exports.default = enhance(EditableTitle);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editableTitle/EditableTitle.js
// module id = 228
// module chunks = 0